import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/Dialog';
import { Button } from '@/components/ui/Button';
import { Textarea } from '@/components/ui/Textarea';

interface CancelDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
  isLoading?: boolean;
  appointmentDate?: string;
}

export function CancelDialog({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
  appointmentDate,
}: CancelDialogProps) {
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = () => {
    if (reason.length < 10) {
      setError('O motivo deve ter pelo menos 10 caracteres.');
      return;
    }
    setError('');
    onConfirm(reason);
  };

  const handleClose = () => {
    setReason('');
    setError('');
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Cancelar agendamento</DialogTitle>
        </DialogHeader>

        <div className="py-4">
          {appointmentDate && (
            <p className="text-sm text-gray-500 mb-4">
              Agendamento: {new Date(appointmentDate).toLocaleDateString('pt-BR')}
            </p>
          )}
          <Textarea
            label="Motivo do cancelamento"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Informe o motivo do cancelamento (mínimo 10 caracteres)"
            rows={3}
            error={error}
          />
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={handleClose} disabled={isLoading}>
            Voltar
          </Button>
          <Button variant="ghost" onClick={handleSubmit} isLoading={isLoading}>
            Confirmar cancelamento
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
